import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteLinkedLogins } from 'api/account';
import DeleteButton from 'components/Button/DeleteButton';
import DeleteConfirmation from 'components/DeleteConfirmation';
import { useFloatingTooltip } from 'hooks/useFloatingTooltip';

const LinkedAccountsItem = ({ linkedAccount, deleteTabelItem }) => {

  const [deleteConfirmOpened, setDeleteConfirmOpened] = useState(false);

  const deleteLinkedAccountRecord = (linkedAccount_id) => {
    deleteLinkedLogins(linkedAccount_id).then(() => {
      setDeleteConfirmOpened(false);
      deleteTabelItem(linkedAccount_id);

    }).catch(() => {
      setDeleteConfirmOpened(false);
    });
  };

  const {
    showTooltip,
    hideTooltip,
    updateTooltip,
    tooltipElement,
  } = useFloatingTooltip('Remove linked account');

  return (
    <div className='linked-accounts__item'>
      <div className="linked-accounts__item-content">
        <div className="linked-accounts__item-name">
          {linkedAccount.name}
        </div>
        <div className="linked-accounts__item-email">
          {linkedAccount.email}
        </div>
      </div>
      {linkedAccount.current ?
        (
          <div className='linked-accounts__item-icon'>
            <FontAwesomeIcon icon={['fa', 'star']} /> Current Account
          </div>
        ) : (
          <div className="linked-accounts__item-delete">
            <DeleteButton
              onClick={() => setDeleteConfirmOpened(true)}
              onMouseEnter={e => {
                showTooltip();
                updateTooltip(e);
              }}
              onMouseMove={e => updateTooltip(e)}
              onMouseLeave={hideTooltip}
            />
          </div>
        )
      }
      {tooltipElement}
      <DeleteConfirmation
        name="delete-confirmation"
        show={deleteConfirmOpened}
        handleClose={(e) => {
          e?.stopPropagation();
          setDeleteConfirmOpened(false);
        }}
        handleConfirm={() => deleteLinkedAccountRecord(linkedAccount.id)}
        deleteText="remove account"
        size="xs"
        header={false}
      >
        <p>
          Once you remove this linked account, you will need to sign in separately to access this account. Are you sure?
        </p>
      </DeleteConfirmation>
    </div>
  );
};

export default LinkedAccountsItem;
